$(function(){
  if( $("body").is(".theme-video") ){

    // js-video-play
    //------------------------------------------------------------
    $(".js-video-play").on('click', function(){

      var _href = $(this).attr("data-href");

      if( $("html").is("[data-mode='pc']") ){
        $.fancybox({
          type: "iframe",
          href: _href,
          width: 800,
          height: 600
        });
      }

      if( $("html").is("[data-mode='sp']") ){
        window.open(_href);
      }


    });
  }
});



// WEBPACK FOOTER //
// ./_src/js/cont/video.js